document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const overlay = document.querySelector('[data-overlay]');
  const panels = document.querySelectorAll('[data-menu-drawer], [data-cart-drawer], [data-search-panel]');
  const closePanels = () => {
    panels.forEach((panel) => { panel.classList.remove('open'); panel.setAttribute('aria-hidden', 'true'); });
    overlay?.classList.remove('open');
    body.classList.remove('panel-open');
  };
  const openPanel = (selector) => {
    closePanels();
    const panel = document.querySelector(selector);
    if (!panel) return;
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('open');
    body.classList.add('panel-open');
  };
  document.querySelectorAll('[data-open-menu]').forEach((el) => el.addEventListener('click', () => openPanel('[data-menu-drawer]')));
  document.querySelectorAll('[data-open-cart]').forEach((el) => el.addEventListener('click', () => openPanel('[data-cart-drawer]')));
  document.querySelectorAll('[data-open-search]').forEach((el) => el.addEventListener('click', () => openPanel('[data-search-panel]')));
  document.querySelectorAll('[data-close-panels], [data-overlay]').forEach((el) => el.addEventListener('click', closePanels));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        button.textContent = 'Added';
        setTimeout(() => window.location.assign('/cart'), 450);
      } catch (error) {
        button.textContent = 'Try again';
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1600);
      }
    });
  });
});
